/**
 * CSV.
 *
 * The quoting rule, the CRLF separator and the UTF-8 BOM are ported verbatim
 * from `analytics-export.ts`, which was the ONE export on the three screens that
 * was already correct.
 *
 * THE BOM IS NOT DECORATION. Without it Excel reads the file as the local
 * codepage, and a building called Björkgränd arrives mangled. It is one
 * character and it is the difference between a usable file and a support
 * ticket.
 */
import { ExportModel } from './export-rows';

/** A field containing a quote, a comma or a newline is quoted, and internal
 *  quotes are doubled. Anything else is written raw, so the common case stays
 *  readable in a text editor. */
export const cell = (value: string): string =>
  /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

export const rowsToCsv = (rows: string[][]): string =>
  rows.map(row => row.map(cell).join(',')).join('\r\n');

export const toCsv = (model: ExportModel): string => {
  const rows: string[][] = [[model.title]];

  for (const line of model.meta) rows.push(line);
  if (model.truncation) rows.push(['TRUNCATED', model.truncation]);

  for (const section of model.sections) {
    rows.push([]);
    rows.push([section.title]);
    if (section.caption) rows.push(['', section.caption]);
    if (section.header.length) rows.push(section.header);
    for (const row of section.rows) rows.push(row);
  }

  return rowsToCsv(rows);
};

export const csvBlob = (csv: string): Blob =>
  // The leading BOM. See the header.
  new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8;' });
